import React, { Fragment, useEffect, useRef, useState } from "react";
import "./Header.css";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { userActions } from "../../context/reducers/user";
import { platformLayout } from "../../utils/constants";
import Loader from "../Loader/Loader";
import { failed, success } from "../../utils/Tostify";
import { signIn } from "../../api/auth";
import { decryptData } from "../../utils/helper";
import { Tooltip } from "reactstrap";
import NotificationSection from "../../modules/Notification";
import { getNotificationCount } from "../../api/Notification";
import noProfileImg from "../../../src/assets/images/noImage.jpg";

function Header({ direction, ...args }) {
  let user = useSelector(state => state.userReducer.user);
  // let role = useSelector((state) => state?.userReducer?.user?.defaultRole?.value?.portalLayout);
  let role = localStorage.getItem("userRole");
  let roleId = localStorage.getItem("roleId");
  const roles = useSelector((state) => state?.userReducer?.user?.roles);
  const defaultPermissions = useSelector((state) => state?.userReducer?.user?.defaultRole?.value?.permissions);
  const matchedRole = roles?.find((role) => role.value._id === roleId);
  const permissions = matchedRole?.permissions || defaultPermissions;
  const orgList = useSelector(state => state.userReducer.user.organizations);
  // const defaultOrg = orgList?.find((org)=> org?.organizationId?._id === user?.defaultLogInOrg);
  const orgDetails =  localStorage.getItem("currentOrgId");
  const defaultOrg = orgList?.find((org)=> org?.organizationId?._id === orgDetails && org?.organizationId?.active === true);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownTwoOpen, setDropdownTwoOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [activeNotification, setActiveNotification] = useState(null);
  const [counts, setCounts] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleLogout = () => {
    dispatch(userActions.logout());
    localStorage.removeItem("userRole");
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
  };
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const toggletwo = () => setDropdownTwoOpen((prevState) => !prevState);
  const [selectedImage, setSelectedImage] = useState(null);
  const currentClinicId = localStorage.getItem("currentHospitalId");

  const handleDefaultLocation = async(clinicId)=>{
    //   const confirmed = await getConfirmation({
    //     title: "Attention!",
    //     entryName : "",
    //     actionBtnTitle: "Yes",
    //     message : "Are you sure want to change location."
    // });
    // if (confirmed) {
        let res;
        try {
            setIsLoading(true);
            // const values = {isChecked: true};
            // res = await updateDefaultOrg({values, dispatch, token, userId: user?._id, defaultOrgId : "", clinicId: clinicId, orgId:  user?.defaultLogInOrg});
            // if (res?.status === "SUCCESS") {
                localStorage.setItem("currentHospitalId", clinicId);
                const values = {email : user?.email, password : "loginFromHeader"};
                setIsLoading(false);
                success(res?.message);
                res = await signIn({ values, dispatch });
                localStorage.setItem("REACT_APP_ENCRYPT_KEY",res.data.ENCRYPT_KEY);
                localStorage.setItem("REACT_APP_ADOBE_READER_CLIENT_ID",res.data.ADOBE_FRONT_KEY);
                const responseData = decryptData(res?.data.encryptedResponse);
                if (res?.status === "SUCCESS") {
                    // success(res?.message);
                    // localStorage.setItem("userRole", responseData?.defaultRole?.value?.portalLayout);
                    dispatch(userActions.loginSuccess(responseData));
                    window.location.reload();
                // }
                }else{
                    setIsLoading(false);
                    failed(res?.message);
                }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    // }
    };

  const getUserRoleName = () => {
    const userRoleId = localStorage.getItem('roleId');
    const roleObject = user?.roles?.find(roleObj => roleObj.value._id === userRoleId);
    return roleObject?.value.roleName || localStorage.getItem('userRole');
  };


  const toggleNotification = (type) => {
    setActiveNotification((prev) => (prev === type ? null : type));
  };

  const handleMouseEnter = (e) => {
    const el = e.target;
    if (el.offsetWidth < el.scrollWidth) {
      setTooltipOpen(true);
    }
  };

  const handleMouseLeave = () => {
    setTooltipOpen(false);
  };

  const NotificationsCount = async () => {
      setIsLoading(true);
      let res;
      try {
          res = await getNotificationCount({userId: user._id, dispatch, role, currentClinicId });
          if (res?.status === "SUCCESS") {
            setCounts(res?.data);
          } else {
            setIsLoading(false);
            failed(res?.message);
          }
      } catch (error) {
          setIsLoading(false);
          failed(res?.message);
      } finally {
          setIsLoading(false);
      }
  };

  useEffect(()=>{
    NotificationsCount();
  },[]);

  const toggleTooltip = () => setTooltipOpen(prev => !prev);

  const emailIconRef = useRef(null);
  const calendarIconRef = useRef(null);
  const alertIconRef = useRef(null);

  return (
    <Fragment>
    {isLoading && <Loader/>}
    <header className="header d-flex justify-content-between align-items-center">
     <div className="d-flex gap-2 align-items-center">
     {role === platformLayout.Organization ? <div className="d-flex gap-2 align-items-center" >
        <img src="/assets/icons/header_blk_peoples.svg" alt="img_profile" />
        <Dropdown isOpen={dropdownTwoOpen} toggle={toggletwo} direction={direction}>
          <DropdownToggle className="pro_text d-flex" caret id="orgClinicDropdown"><p className="text-truncate mb-0" onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}>{defaultOrg?.organizationId.active && defaultOrg?.organizationId?.name + " - " + defaultOrg?.clinicId?.find((obj)=> obj?._id === localStorage.getItem("currentHospitalId"))?.name}</p><i className="fa fa-angle-down"></i></DropdownToggle>
          {/* Tooltip */}
          <Tooltip
            placement="bottom"
            isOpen={tooltipOpen}
            target="orgClinicDropdown"
            toggle={toggleTooltip}
            style={{ maxWidth: "400px",color: "white",
              backgroundColor: "#000" }}
          >
            {defaultOrg?.organizationId?.name +
              " - " +
              defaultOrg?.clinicId?.find(
                (obj) => obj?._id === localStorage.getItem("currentHospitalId")
              )?.name}
          </Tooltip>
          <DropdownMenu {...args}>
          {defaultOrg?.clinicId?.length > 0 ?
          (() => {
            const addedClinics = new Set();
            return defaultOrg?.clinicId
              ?.filter(clinic => clinic.active === true && !addedClinics.has(clinic?._id) && addedClinics.add(clinic?._id))
              .map(clinic => (
                <DropdownItem
                  key={clinic?._id}
                  active={clinic?._id === localStorage.getItem("currentHospitalId")}
                  onClick={() => handleDefaultLocation(clinic?._id)}
                >
                  {defaultOrg?.organizationId?.name + " - " + clinic?.name}
                </DropdownItem>
              ));
          })()
          : null
        }
        </DropdownMenu>
        </Dropdown>
        </div> : null}
      </div>

      <div className="d-flex justify-content-between align-items-center main_prof">

        <div className="d-flex spacing">
          {/* Email Notification */}
          <div className="main_badge position-relative">
            <div className="email_block" onClick={() => toggleNotification('email')}>
              <i className="fa-solid fa-envelope" ref={emailIconRef}></i>
            </div>
            {counts?.email > 0 && <div className="yellow_badge">{counts?.email}</div>}
          </div>

          {/* Calendar Notification */}
          <div className="main_badge position-relative">
            <div className="callender_block" onClick={() => toggleNotification('calendar')}>
              <i className="fa-solid fa-calendar-days" ref={calendarIconRef}></i>
            </div>
            {counts?.calendar > 0 && (
              <div className="yellow_badge green_blk">{counts?.calendar}</div>
            )}
          </div>

          {/* Bell Notification */}
          <div className="main_badge position-relative">
            <div className="notification_block" onClick={() => toggleNotification('alert')}>
              <i className="fa-solid fa-bell" ref={alertIconRef}></i>
            </div>
            {counts?.alert > 0 && <div className="yellow_badge red_blk">{counts?.alert}</div>}
          </div>

          {/* Common Notification Section */}
          {activeNotification === 'email' && emailIconRef.current && (
            <NotificationSection
              open={true}
              onClose={() => setActiveNotification(null)}
              anchorEl={emailIconRef.current}
              type="email"
              getNotificationCount = {NotificationsCount}
            />
          )}

          {activeNotification === 'calendar' && calendarIconRef.current && (
            <NotificationSection
              open={true}
              onClose={() => setActiveNotification(null)}
              anchorEl={calendarIconRef.current}
              type="calendar"
              getNotificationCount = {NotificationsCount}
            />
          )}

          {activeNotification === 'alert' && alertIconRef.current && (
            <NotificationSection
              open={true}
              onClose={() => setActiveNotification(null)}
              anchorEl={alertIconRef.current}
              type="alert"
              getNotificationCount = {NotificationsCount}
            />
          )}
        </div>

        <div className="profile_block d-flex align-items-center">
          <div className="drop_block">
            <Dropdown isOpen={dropdownOpen} toggle={toggle} direction={direction}>
              <DropdownToggle className="pro_text d-flex profile_desc" caret>
                <div>
                  {selectedImage ? (
                    <img src={selectedImage} alt="img_profile" className="img_profile" />
                  ) : user?.profilePhoto?.signedUrl ? (
                    <img src={user.profilePhoto.signedUrl} alt="img_profile" className="img_profile" />
                  ) : user?.profile_image?.signedUrl ? (
                    <img src={user.profile_image.signedUrl} alt="img_profile" className="img_profile" />
                  ) : (
                    <img src={noProfileImg} alt="img_profile" className="img_profile" />
                  )}
                </div>
                <h6>{[user?.firstName, user?.lastName].filter(Boolean).join(' ')}<br /><span className="text-start">{getUserRoleName()}</span></h6>
                <i className="fa fa-angle-down"></i>
              </DropdownToggle>
              <DropdownMenu {...args}>
                <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => role === "Patient" ? navigate("/app/patient/profile") : navigate("/app/profile")}>
                  <i className="fa-solid fa-calendar-days"></i>
                  <h6>My Profile</h6>
                </DropdownItem>
                {/* Support button - show only for Organization role */}
                {role === platformLayout.Organization && !permissions?.find((obj)=> obj?.objectName === "SupportRequests")?.isHidden && (
                  <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => navigate("/app/support")}>
                    <i className="fa-solid fa-headset"></i>
                    <h6>Support</h6>
                  </DropdownItem>
                )}
                {/* Messages button - show for Organization and Patient roles based on permissions */}
                {role !== platformLayout.Platform && !permissions?.find((obj)=> obj?.objectName === "Messages")?.isHidden && (
                  <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => navigate("/app/messages")}>
                    <i className="fa-solid fa-envelope envelop"></i>
                    <h6>Messages</h6>
                  </DropdownItem>
                )}
                <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={handleLogout}>
                  <i className="fa-solid fa-right-from-bracket"></i>
                  <h6>Logout</h6>
                  </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
      </div>
    </header>
    </Fragment>
  );
}
Header.propTypes = {
  direction: PropTypes.oneOf([0, 10, 0, 0])
};

export default Header;
